// extracted by mini-css-extract-plugin
export default {"tabs":"NewOrder_tabs__2pbmP","selected":"NewOrder_selected__MaHjZ","previous":"NewOrder_previous__jFi2t"};